import jp from "jsonpath";
import api from "../config";
const pluginUrl = api[api.status].pluginUrl;

export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export const getHeightAndWidthFromDataUrl = async dataURL => new Promise(resolve => {
  const img = new Image()
  img.onload = () => {
    resolve(`${img.width}x${img.height}`);
  }
  img.src = dataURL
})

export function getCookieValue(name) {
  const cookies = document.cookie;
  const cookiesArray = cookies.split(';');
  for (let i = 0; i < cookiesArray.length; i++) {
    const cookie = cookiesArray[i].trim();
    if (cookie.startsWith(name + '=')) {
      return cookie.substring(name.length + 1);
    }
  }

  return null;
}

export function formatDate(dateString) {
  const date = new Date(dateString);
  const formatter = new Intl.DateTimeFormat("en", { month: "short" });
  const day = date.getDate();
  const month = formatter.format(date);
  const year = date.getFullYear();
  return `${day} ${month}, ${year}`;
}

export function formatFeedInterval(milliseconds) {
  if (milliseconds < 1000) {
    return milliseconds + " milliseconds";
  } else if (milliseconds < 60000) {
    var seconds = Math.floor(milliseconds / 1000);
    return seconds + " seconds";
  } else if (milliseconds < 3600000) {
    var minutes = Math.floor(milliseconds / 60000);
    return minutes + " minutes";
  } else if (milliseconds < 86400000) {
    var hours = Math.floor(milliseconds / 3600000);
    return hours + " hours";
  } else {
    var days = Math.floor(milliseconds / 86400000);
    return days + " days";
  }
}

export function xmlToJson(xml) {
  var xmlDoc = new DOMParser().parseFromString(xml, 'text/xml');
  var json = {};
  var rootElement = xmlDoc.documentElement;
  json[rootElement.nodeName] = parseNode(rootElement);

  function parseNode(node) {
    var obj = {};

    if (node.attributes.length > 0) {
      obj['@attributes'] = {};
      for (var j = 0; j < node.attributes.length; j++) {
        var attribute = node.attributes.item(j);
        obj['@attributes'][attribute.nodeName] = attribute.nodeValue;
      }
    }

    if (node.hasChildNodes() && node.childNodes.length === 1 && node.childNodes[0].nodeType === 3) {
      obj = node.childNodes[0].nodeValue.trim();
    }

    if (node.hasChildNodes()) {
      for (var i = 0; i < node.childNodes.length; i++) {
        var childNode = node.childNodes[i];
        if (childNode.nodeType === 1) {  // 
          var nodeName = childNode.nodeName;
          if (typeof obj[nodeName] == "undefined") {
            obj[nodeName] = parseNode(childNode);
          } else {
            if (typeof obj[nodeName].push == "undefined") {
              var old = obj[nodeName];
              obj[nodeName] = [];
              obj[nodeName].push(old);
            }
            obj[nodeName].push(parseNode(childNode));
          }
        }
      }
    }
    return obj;
  }
  return json;
}

export function findArrayInNestedObject(obj) {
  for (const key in obj) {
    if (Array.isArray(obj[key])) {
      return { key: key, value: obj[key] };
    } else if (typeof obj[key] === 'object' && obj[key] !== null) {
      const result = findArrayInNestedObject(obj[key]);
      if (result) {

        return result;
      }
    }
  }
}

// export function transformDataToFields(sourceData, path) {
//   const pathData = jp.query(sourceData, path);
//   const fields = [];
//   const keys = Object.keys(pathData[0]);
//   let i = 0;
//   do {
//     fields.push({
//       name: keys[i],
//       values: jp.query(sourceData, `${path}.${keys[i]}`)
//     });
//     i++;
//   } while (i < keys.length);
//   return fields;
// }

export function isURL(str) {
  try {
    new URL(str);
    return true;
  } catch (error) {
    return false;
  }
}
export function isImageURL(url) {
  var imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg'];
  var fileExtension = url.split('.').pop().toLowerCase().trim();  
  return imageExtensions.find(extension => extension === (`.${fileExtension}`));
}

export function bytesToKB(fileSize) {
  if (fileSize === 0) {
    return "0 KB";
  }
  const kBytes = fileSize / 1024;
  return kBytes.toFixed(2) + " KB";
}

export async function getPreviewAndSizeFromFile(file) {
  file.status = 1;
  file.preview = URL.createObjectURL(file);
  file.formattedSize = formatBytes(file.size);
  file.pixelSize = await getHeightAndWidthFromDataUrl(file.preview);
  return file;
}

export function camelCaseToWords(str) {
  function capitalizeFirstLetter(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  return str.replace(/([a-z])([A-Z])/g, '$1 $2').split(/\s+/).map(capitalizeFirstLetter).join(' ');
}

export function processAdTypes(obj) {
  let result = obj.map(item => {
    let subTypes = item.subTypes.map(subItem => { return { name: camelCaseToWords(subItem.name), value: subItem.name } });
    return {
      name: camelCaseToWords(item.name),
      value: item.name,
      subTypes: subTypes
    }
  });
  return result;
}

export function createFigmaPlugin() {
  if (document.querySelector('#figma-modal-body iframe')) {
    document.querySelector('#figma-modal-body iframe').remove();
  }
  const iframe = document.createElement('iframe');
  iframe.width = '100%';
  iframe.height = '100%';
  // iframe.src = 'https://test-plugin.adcropper.com/timelineFunction.html'
  iframe.src = pluginUrl;

  document.querySelector('#figma-modal-body').appendChild(iframe);
  return iframe;
}

export function scaleElementToFitParent(element, setScalePercentage, scaleRatio) {
  if (element) {
    element.style.position = 'absolute';
    element.style.top = '50%';
    element.style.left = '50%';
    element.style.transformOrigin = "center center";

    let parent = element.parentElement;

    if (!parent) {
      return;
    }

    const parentWidth = parent.clientWidth;
    const parentHeight = parent.clientHeight;
    const elementWidth = element.clientWidth;
    const elementHeight = element.clientHeight;
    let scale;
    if (elementWidth > parentWidth) {
      scale = Math.min((parentWidth - scaleRatio) / elementWidth, (parentHeight - scaleRatio) / elementHeight);
    } else if (elementHeight > parentHeight) {
      scale = Math.min((parentHeight - scaleRatio * 2) / elementHeight, (parentWidth - scaleRatio * 2) / elementWidth);
    } else {
      scale = Math.min((parentWidth - scaleRatio) / elementWidth, (parentHeight - scaleRatio) / elementHeight);
    }

    element.style.transform = `translate(-50%, -50%) scale(${scale})`;
    if (setScalePercentage) {
      setScalePercentage(scale * 100);
    }
  }
}

export function cleanString(input) {
  // Remove non-ASCII characters
  input = input.replace(/[^\x00-\x7F]/g, '');

  // Remove blank spaces
  input = input.replace(/\s+/g, '');

  // Remove non-English characters
  input = input.replace(/[^a-zA-Z0-9]/g, '');

  input = input.toLowerCase();
  return input;
}

export function sortAlphabetically(array, key) {
  return array
    .map(item => ({ ...item }))
    .sort((a, b) => a[key].localeCompare(b[key]));
}

export function sortByWidth(array, key) {
  return array.map(item => ({ ...item }))
    .sort((a, b) => {
      const widthA = Number(a[key].split('x')[0]);
      const widthB = Number(b[key].split('x')[0]);
      return widthA - widthB; 
    });
};


export function getStyleValue(styleString, property) {
  // Property ismi ile eşleşen kısmı bulmak için regex oluşturuyoruz
  const regex = new RegExp(`${property}\\s*:\\s*([^;]+)`, 'i');
  const match = styleString.match(regex);

  if (!match) return null; // Eğer eşleşme yoksa null döndür

  let value = match[1].trim();

  // Eğer value var() ile başlıyorsa, içindeki varsayılan değeri ayıklıyoruz
  const varRegex = /var\([^\),]+,\s*([^\)]+)\)/;
  const varMatch = value.match(varRegex);

  // Varsayılan değeri bulursak onu döndür, yoksa mevcut değeri döndür
  return varMatch ? varMatch[1].trim() : value;
}

export function rgbStringToHex(rgb) {
  // RGB(A) stringini ayıklama: örneğin, 'rgba(255, 99, 71, 0.5)' veya 'rgb(255, 99, 71)' formatında.
  const result = rgb.match(/(\d+(\.\d+)?)/g);

  if (!result || result.length < 3) {
    return rgb;
  }

  // R, G, B bileşenlerini al ve alpha varsa al yoksa 1 olarak ayarla
  const r = parseInt(result[0], 10);
  const g = parseInt(result[1], 10);
  const b = parseInt(result[2], 10);
  const a = result[3] !== undefined ? parseFloat(result[3]) : 1;

  // RGB'den HEX'e çevirme fonksiyonu
  const toHex = (component) => component.toString(16).padStart(2, '0');

  // Renk değerlerini HEX formatında birleştirme
  let hexColor = `#${toHex(r)}${toHex(g)}${toHex(b)}`;

  // Alpha değeri varsa ve 1'den farklıysa HEX olarak ekleme
  if (a < 1) {
    hexColor += toHex(Math.round(a * 255));
  }

  return hexColor;
}

export function paginateArray(array, pageNumber, itemsPerPage) {
  const startIndex = (pageNumber - 1) * itemsPerPage; // Başlangıç indeksi
  const endIndex = startIndex + itemsPerPage; // Bitiş indeksi
  return array.slice(startIndex, endIndex); // Belirli aralığı döndür
}

// Sleep
export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export function updateAllHistoryStateByMatchingCondition(previousLocations, dispatch, updateState, conditionA, conditionB) {
  if (Array.isArray(previousLocations)) {
    let i = 0;
    do {
      const history = previousLocations[i];
      if (history.location?.state && history.location?.state[conditionA]) {
        if (history.location?.state[conditionA]._id === conditionB) {
          dispatch({
            type: "@@router/UPDATE_PREVIOUS_STATE",
            payload: {
              index: i, // Geçmişteki öğe
              updates: updateState, // Güncellenecek state
            },
          });
        } 
      }
      i++;
    } while (i < previousLocations.length);
  }
}